import { render } from "./DialogChooser.vue?vue&type=template&id=a41d8618&scoped=true"
import script from "./DialogChooser.vue?vue&type=script&lang=js"
export * from "./DialogChooser.vue?vue&type=script&lang=js"

import "./DialogChooser.vue?vue&type=style&index=0&id=a41d8618&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a41d8618"

export default script